module.exports = __webpack_public_path__ + "static/media/ic_email_danger.ca3e4163.svg";